import React from "react";
import { Box, useTheme } from "@mui/material";
import AIAssistantChat from "../../components/Chat/AIAssistantChat";
import Header from "../../components/Header";
import { tokens } from "../../theme";

const AIAssistantPage = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <Box m="20px">
      <Header
        title="KI-ASSISTENT"
        subtitle="Intelligente Analyse, Prognosen und Antworten auf Ihre geschäftlichen Fragen"
      />
      <Box
        height="75vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .name-column--cell": {
            color: colors.greenAccent[300],
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.blueAccent[700],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.primary[400],
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: colors.blueAccent[700],
          },
          "& .MuiCheckbox-root": {
            color: `${colors.greenAccent[200]} !important`,
          },
        }}
      >
        <AIAssistantChat />
      </Box>
    </Box>
  );
};

export default AIAssistantPage;